import React from "react";
import { ReactNode } from "react";

interface IBoldText {
  children?: ReactNode | ReactNode[];
}

export const BoldText: React.FC<IBoldText> = ({ children }: IBoldText) => {
  return <span style={{ fontWeight: "100" }}>{children}</span>;
};
